/* Svensk katalog for locale-investment-inbox.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'investments.inboxTitle': 'Inkorg',
  'investments.inboxIntro': 'Ladda upp dokument för köp och försäljning av fonder och aktier. Plumme läser dokumentet och förbereder registreringen.',
  'investments.supportNotice': 'Fonder och aktier stöds fullt ut för registrering och bokföring. Andra investeringstyper kan kännas igen men måste tills vidare hanteras manuellt.',
  'investments.sendToEmail': 'Skicka till',
  'investments.copyEmail': 'Kopiera e-postadress',
  'investments.folder': 'Mapp',
  'investments.inboxFolder': 'Inkorg',
  'investments.trashFolder': 'Papperskorg',
  'investments.documentationFolder': 'Dokumentation',
  'investments.searchDocuments': 'Sök i dokument',
  'investments.emptyFolder': 'Det finns inga dokument i den här mappen.',
  'investments.documentNotAnalyzed': 'Redo för analys',
  'investments.superPlummaProposal': 'Förslag från SuperPlumma',
  'investments.reviewAndApprove': 'Kontrollera och godkänn',
  'investments.notAnalyzedHelp': 'Dokumentet har tagits emot och är redo för analys.',
  'investments.restoreDocument': 'Återställ',
  'investments.sendToDocumentation': 'Skicka till dokumentation',
  'investments.moveToTrash': 'Flytta till papperskorgen',
  'investments.moreActions': 'Fler åtgärder',
  'investments.registerPurchase': 'Registrera köp',
  'investments.registerSale': 'Registrera försäljning',
  'investments.tradeDate': 'Affärsdag',
  'investments.unitPrice': 'NAV / kurs',
  'investments.previewDocumentFallback': 'Dokument',
  'investments.previewMissingFileLink': 'Fillänk saknas',
  'investments.openDocument': 'Öppna dokument',
  'investments.addBankAccount': '+ Lägg till bankkonto …',
  'investments.addBankTitle': 'Lägg till bankkonto',
  'investments.addBankSave': 'Lägg till konto',
  'investments.newBankAccountNote': 'Nytt bankkonto skapas i kontoplanen',
  'investments.newBankAccountCode': 'Bankkontot får nästa lediga konto i 192x-serien: {{code}}.',
  'investments.bankName': 'Kontonamn',
  'investments.bankNamePlaceholder': 'T.ex. Investeringskonto',
  'investments.bankAccountNumber': 'Kontonummer',
  'investments.openingBalance': 'Startsaldo',
  'investments.openingBalanceDate': 'Datum för startsaldo',
  'investments.bankNameRequired': 'Ge bankkontot ett namn.',
  'investments.bankNumberRequired': 'Fyll i kontonummer.',
  'investments.bankOpeningRequired': 'Fyll i startsaldo och datum för startsaldo. Skriv 0 om saldot var noll.',
  'investments.bankNumberExists': 'Bankkontot är redan registrerat.',
  'investments.bankLedgerSeriesFull': 'Det finns inget ledigt konto i 192x-serien. Lägg till kontot i Inställningar.',
  'investments.bankAdded': 'Bankkonto tillagt.',
  'investments.addBankFailed': 'Det gick inte att lägga till bankkontot.',
  'investments.addBankUnavailable': 'Bankkonton är inte kopplade till backend.',
  'investments.addBankUnsupportedCountry': 'Det här bankkontoflödet stöds tills vidare bara för norska företag.',
  'investments.newInvestmentAccount': 'Nytt investeringskonto',
  'investments.investmentAccounts': 'Investeringskonton och depåer',
  'investments.settingsTab': 'Investeringar',
  'investments.settingsTitle': 'Investeringskonton och depåer',
  'investments.settingsHelp': 'Hantera kontona hos banker, fondbolag och andra leverantörer.',
  'investments.editInvestmentAccount': 'Redigera investeringskonto',
  'investments.investmentAccountsHelp': 'Registrera kontona hos varje leverantör. Samma investering kan ägas i flera depåer, medan huvudbokskontot fortfarande är fyrsiffrigt.',
  'investments.noInvestmentAccounts': 'Inga investeringskonton har registrerats ännu.',
  'investments.saveInvestmentAccount': 'Spara investeringskonto',
  'investments.investmentAccountId': 'Bank / depå',
  'investments.targetInvestmentAccountId': 'Ny bank / depå',
  'investments.accountNumber': 'Konto- eller depånummer (valfritt)',
  'investments.defaultSettlementAccount': 'Standardkonto för likvid',
  'investments.noDefaultSettlementAccount': 'Inget standardkonto för likvid',
  'investments.accountActive': 'Investeringskontot är aktivt',
  'investments.custody': 'Värdepappersdepå',
  'investments.fund_account': 'Fondkonto',
  'investments.other': 'Annat investeringskonto',
  'investments.subledgerCode': 'Internt investeringsnummer',
  'investments.createInstrumentFromDocument': '{{name}} (skapas när du sparar)',
  'investments.providerHelp': 'Var investeringen förvaras, till exempel Storebrand eller Nordnet. Ange gärna depånummer när det är relevant.',
  'investments.settlementAccountHelp': 'Företagets konto som debiterades eller krediterades. Ett handelskonto hos leverantören måste registreras som ett eget bank-/likvidkonto i Inställningar. Ett AS kan inte använda en privat aksjesparekonto (ASK).',
  'investments.investmentAccountInvalid': 'Kontrollera namn, leverantör och kontotyp.',
  'investments.investmentAccountNotFound': 'Investeringskontot finns inte eller är inaktivt.',
  'investments.investmentAccountDuplicate': 'Det finns redan ett investeringskonto med samma namn.',
  'investments.investmentAccountRequired': 'Välj investeringskonto när leverantören har flera konton.',
  'investments.investmentAccountQuantityInvalid': 'Vald depå har inte tillräckligt många registrerade andelar för händelsen.',
});
